import { ConnectedPosition } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';
import { AbsenceEmployee } from '@qaroni-app/absences/types/absence-employee';
import { Holiday } from '@qaroni-app/holidays/types/holiday';
import {
  ShiftJson,
  ShiftJsonDate,
} from '@qaroni-app/work-calendar/types/schedule';

export interface CalendarOverlayData {
  absences?: AbsenceEmployee[];
  adminSchedules?: scheduleAdminData[];
  date?: Date;
  holidays: Holiday[];
  shifts: ShiftJsonDate[];
}

export interface scheduleAdminData {
  scheduleName: string;
  shifts: ShiftJson[];
}

export const DAY_EVENT_DATA = new InjectionToken<CalendarOverlayData>(
  'DAY_EVENT_DATA'
);

export const TimetableDetailsOverlayPositions: ConnectedPosition[] = [
  {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -10,
  },
  {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 10,
  },
  {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetY: -10,
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: 10,
  },
  {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetY: -10,
  },
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetY: 10,
  },
];
